"use strict";

var _require = require('./ReactHeight'),
    ReactHeight = _require.ReactHeight;

ReactHeight.ReactHeight = ReactHeight;
module.exports = ReactHeight;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-height/lib/index.js
// module id = 669
// module chunks = 0